export const isObjEmpty = (obj) => !Boolean(Object.keys(obj).length);
